/**
* SEO Popups JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Popups component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'seo-popups',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.seo-popups' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--seo-popups' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          perPage: 5,
          perMove: 1,
          focus: 'center',
          gap: '32px',
          autoWidth: true,
          direction: window.isRtl ? 'rtl' : 'ltr',
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-popups', COMPONENT );
} )( app );
